
// Obecna trida - konkretni navazani bude pak napriklad v (budoucim) header.js, modal-search.js, .. ktery bude vyuzivat tuto tridu
// prima inspirace https://tympanus.net/codrops/2021/10/06/how-to-implement-and-style-the-dialog-element/
class upceModal {

	/**
	 * Inicializace pomoci unikatniho aliasu
	 * 
	 * @param {string} ['']	alias dialogu (suffix)
	 * @param {boolean} [false] disableEsc - jestli ma byt potlaceno zavreni pomoci ESC
	 */
	constructor(alias = '', disableEsc = false) {

		// pojmenovani trid se musi shodovat s modal.twig

		// css trida pro html element dialog s pomocnou css tridou vytvorenou pomoci aliasu
		const dialog_class = 'dialog.' + 'dialog_' + alias;

		// id oteviraciho tlacitka / click mimo dialog
		const open_dialog_button_id = 'open_dialog_' + alias;

		// id zaviraciho tlacitka / click v dialog
		const close_dialog_button_id = 'close_dialog_' + alias;

		this.dialog = document.querySelector(dialog_class);

		// dialog nemusi existovat
		if (this.dialog === null) {
			// console.warn('UPCE', 'Dialog', dialog_class, 'missing');
			return false;			
		}

    this.openDialogBtn = document.getElementById(open_dialog_button_id);
    this.closeDialogBtn = document.getElementById(close_dialog_button_id);

		this.disableEsc = disableEsc;

		this.initElements();
		this.initHandlers();		

		return true;

	}


	// Nacteni vybranych elementu uvnitr dialogu a nastaveni 1. a posledniho elementu
	// Pouzivame k udrzeni focusu pouze uvnitr otevreneho dialogu
	initElements() {

		const elements = this.dialog.querySelectorAll(
      'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
    );

		this.firstElement = elements[0];
    this.lastElement = elements[elements.length - 1];
	
	}

	/**
	 * Inicializace handleru - trapFocus, openDialog, closeDialog
	 */
	initHandlers() {

		// Trap focus - chyceni focusu pouze na elementy v ramci popupu
		this.trapFocus = (e) => {
			if (e.key === "Tab") {
				const tabForwards = !e.shiftKey && document.activeElement === this.lastElement;
				const tabBackwards = e.shiftKey && document.activeElement === this.firstElement;
	
				if (tabForwards) {
					// only TAB is pressed, not SHIFT simultaneously
					// Prevent default behavior of keydown on TAB (i.e. focus next element)
					e.preventDefault();
					this.firstElement.focus();
				} else if (tabBackwards) {
					// TAB and SHIFT are pressed simultaneously
					e.preventDefault();
					this.lastElement.focus();
				}
			}
		}
			
		// Otevreni dialogu 
		this.openDialog = (e) => {
      
			// nutna kontrola na to, jestli jiz dialog neni otevreny
			if (this.dialog.open) {
				return false;	
			}
				
			this.dialog.showModal();
      
      // ESC funguje nativne
      // pokud by byla potreba zrusit nativni zavirani pomoci esc lze vlozit ten handler
			if (this.disableEsc) {
				this.dialog.addEventListener("keydown", (e) => {
						if (e.key === "Escape") {
							e.preventDefault();
						}
				});
			}	else {
				this.dialog.addEventListener("keydown", (e) => {
					if (e.key === "Escape") {
						this.closeDialog(e);
					}
				});
			}
      
      this.dialog.addEventListener("keydown", this.trapFocus);

			const event = new Event("open");
			this.dialog.dispatchEvent(event);

    };

		// zavreni dialogu
    this.closeDialog = (e) => {

			// If the buttons of the dialog are contained inside a <form>
			// Use event.preventDefault()
			e.preventDefault();

      // Remove trapFocus once dialog closes
      this.dialog.removeEventListener("keydown", this.trapFocus);

			this.dialog.setAttribute('closing', ""); 
			// any animation end
			this.dialog.addEventListener('animationend', () => {

				this.dialog.removeAttribute('closing');
				this.dialog.close(); // toto vyvola closeDialogEsc
				this.openDialogBtn.focus();
		
			}, {once: true}); 

    };

		// attach handlers
		this.openDialogBtn.addEventListener("click", this.openDialog);
		this.closeDialogBtn.addEventListener("click", this.closeDialog);

	}

	// kontrola zda lze modal pouzivat
	status() {		
		return (this.dialog !== null);
	}

}

// workaround kvuli dostupnosti
window.upceModal = upceModal;
